import React from 'react';

import { List } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import BookButton from './BookButton';
import ShiftsList from './ShiftsList';

import styles from '../../../styles';

const SelectedShifts = ({
  selectedShifts = [],
  removeFromSelectedShifts,
  openDialog,
  clearSelectedShifts,
  refetchBookings
}) =>
  selectedShifts.length ? (
    <div>
      <Subheader style={styles.darkContainerTitle}>
        Your Selected Shifts
      </Subheader>
      <List style={styles.ListShiftsMui}>
        <div className="col-xs-12 text-center">
          <BookButton
            clearSelectedShifts={clearSelectedShifts}
            openDialog={openDialog}
            selectedShifts={selectedShifts}
            refetchBookings={refetchBookings}
          />
        </div>
        <div className="col-xs-12">
          <ShiftsList
            selectedShifts={selectedShifts}
            removeFromSelectedShifts={removeFromSelectedShifts}
          />
        </div>
      </List>
    </div>
  ) : null;

export default SelectedShifts;



// WEBPACK FOOTER //
// ./src/components/Book/SelectedShifts/index.js